import React from 'react';

import { Blocks as CommonBlocks } from './Types.jsx';
import { withBlockRendering } from '../utility/Config.jsx';
import ContentContainer from './ContentContainer.jsx';
import Utilities from '../utility/Utilities.jsx';

const _PageHeader = withBlockRendering(ContentContainer, CommonBlocks.get());
function PageHeader(props) {
    const handleClick = () => {
        if (props.onBlockClick) {
            props.onBlockClick(Utilities.Config.Id.DocumentSettings);
        }
    }
    let style;
    let className = 'page__header';
    let contentConfig = props.contentConfig;
    let _props = { ...props };
    if (!props.editor) {
        if (props.onPageProps) {
            contentConfig = props.onPageProps();
        }
        if (contentConfig && contentConfig.Config && contentConfig.Config.document) {
            contentConfig = contentConfig.Config.document;
        }
        if (contentConfig.config && contentConfig.config.Style && contentConfig.config.Style.pageHeader && contentConfig.config.Style.pageHeader.Config) {
            contentConfig = contentConfig.config.Style.pageHeader;
        }
        if (props.builder) {
            style = { cursor: 'pointer' };
            _props.onDragEnter = undefined;
            _props.onDragOver = undefined;
            _props.onDragStart = undefined;
        }
        if (!contentConfig || !contentConfig.Config || !contentConfig.Config.blocks || contentConfig.Config.blocks.length == 0) {
            if (props.builder) {
                style.position = 'relative';
                style.textAlign = 'center';
                style.zIndex = 3;
                return <div style={style} onClick={handleClick}>Click Here to Customize The Page Header{Utilities.Builder.emptyBlockPlaceholder()}</div>
            }
            return null;
        }
    } else {
        className += ' editor';
        _props.onDragEnter = e => {
            if (e && e.currentTarget && e.currentTarget.className && e.currentTarget.className.indexOf && e.currentTarget.className.indexOf('page__header') >= 0) {
                return;
            } else if (props.onDragEnter) {
                props.onDragEnter(e)
            }
        }
        let config = props.parentBlock && props.parentBlock.config;
        if (!config && props.config && props.config.Config && props.config.Config.document && props.config.Config.document.config && props.config.Config.document.config.Style) {
            config = props.config.Config.document.config;
        }
        if (config && config.Style) {
            style = Utilities.Config.getStyle(config.Style, props, (propName) => {
                switch (propName) {
                    case 'pageHeader':
                        return true;
                }
            })
        }
    }
    return <_PageHeader {..._props} className={className} containerStyle={style} contentConfig={contentConfig} onClick={handleClick} />
}

export default PageHeader;